import { render } from "./customers-company-modal.vue?vue&type=template&id=0872f2fe"
import script from "./customers-company-modal.vue?vue&type=script&lang=js"
export * from "./customers-company-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__